var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as types from './types';
var initialState = {
    labels: {},
    custom: {},
    user: {},
};
export default function telemetryReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types.SET_TELEMETRY_LABELS:
            return __assign(__assign({}, state), { labels: __assign(__assign({}, state.labels), action.payload) });
        case types.SET_TELEMETRY_CUSTOM:
            return __assign(__assign({}, state), { custom: __assign(__assign({}, state.custom), action.payload) });
        case types.SET_TELEMETRY_USER:
            return __assign(__assign({}, state), { user: __assign(__assign({}, state.user), action.payload) });
        default:
            return state;
    }
}
